import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { packageIncludes } from '../data/comparison';
export function OfferSection() {
  return <section id="buy" className="flex w-full scroll-mt-0 flex-col justify-center bg-white py-6 sm:min-h-0 sm:py-20 [@media(max-width:640px)]:min-h-[100svh]" aria-labelledby="offer-title" data-id="element-144" data-mp="de55l1s0ikjq">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-145" data-mp="mejusc83kjsi">
        <div className="text-center" data-id="element-146" data-mp="md0fanu9mcrs">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-clay sm:text-[11px] sm:tracking-[0.2em]" data-id="element-147" data-mp="re69kq3kq83f">
            ⏰ Limited-time offer
          </p>
          <h2 id="offer-title" className="mt-1.5 font-display text-xl font-black tracking-tight text-court-950 sm:mt-4 sm:text-4xl" data-id="element-148" data-mp="wawv3sy5dvw8">
            The launch price ends in:
          </h2>
          <div className="mt-3 sm:mt-8" data-id="element-149" data-mp="12niedon92hv2">
            <Countdown data-id="element-150" data-mp="12oa96x90wbka" />
          </div>
          <p className="mt-2.5 text-[11px] leading-snug text-court-700 sm:mt-6 sm:text-sm" data-id="element-151" data-mp="12pczb2yiu9z5">
            After that, the price goes up by $5 and never comes back down.
          </p>

          <div className="mx-auto mt-3 max-w-md sm:mt-8" data-id="element-152" data-mp="sxyr86si81ue">
            <div className="flex items-center justify-between text-[9px] font-bold uppercase tracking-[0.12em] text-clay sm:text-[11px] sm:tracking-[0.14em]" data-id="element-153" data-mp="owwsrs6evtth">
              <span data-id="element-154" data-mp="1lk0bklkvb9yp">🔴 Limited spots</span>
              <span data-id="element-155" data-mp="1gocn68e7mku9">72% claimed</span>
            </div>
            <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-court-950/10 sm:mt-2 sm:h-2" data-id="element-156" data-mp="1glgqene3m27e">
              <div className="h-full w-[72%] rounded-full bg-clay" data-id="element-157" data-mp="17mlfiy0403xr" />
            </div>
          </div>
        </div>

        <div className="mt-4 grid gap-5 rounded-2xl border border-court-950/10 bg-bone p-4 sm:mt-16 sm:gap-10 sm:rounded-3xl sm:p-12 lg:grid-cols-[1fr_0.9fr] lg:items-start" data-id="element-158" data-mp="172fxam3e598">
          <div data-id="element-159" data-mp="3ttzrq7u4qcno">
            <p className="text-[9px] font-bold uppercase tracking-[0.16em] text-court-600 sm:text-[11px] sm:tracking-[0.18em]" data-id="element-160" data-mp="3tthnanxbcs4o">
              Limited-time offer
            </p>
            <p className="mt-1 text-[10px] leading-snug text-court-700 sm:mt-3 sm:text-base sm:leading-relaxed" data-id="element-161" data-mp="2lc39j0le9bw">
              Everything included. One single price. Complete package. No hidden fees. No surprises.
            </p>

            <h3 className="mt-2.5 font-display text-base font-black leading-tight tracking-tight text-court-950 sm:mt-8 sm:text-2xl" data-id="element-162" data-mp="3b38ayl7tbjz9">
              🏆 Complete Package
              <span className="block" data-id="element-163" data-mp="315c1ryyfqz3s">TENNIS 360™ — 12 Volumes + 6 Bonuses</span>
            </h3>

            <div className="mt-3 flex flex-wrap items-end gap-x-3 gap-y-1 sm:mt-8 sm:gap-4" data-id="element-164" data-mp="313hi0nywhd1a">
              <span className="text-sm text-court-600 line-through sm:text-lg" data-id="element-165" data-mp="3622f4eiuvgli">
                Total value: $318
              </span>
              <span className="font-display text-4xl font-black leading-none tracking-tight text-court-950 sm:text-6xl" data-id="element-166" data-mp="2x408njgcrvqu">
                $27
              </span>
              <span className="pb-0.5 text-xs font-medium text-court-700 sm:pb-1.5 sm:text-sm" data-id="element-167" data-mp="2djrxmpgsfjw7">
                one-time
              </span>
            </div>
            <div className="mt-2.5 flex flex-wrap gap-2 sm:mt-4" data-id="element-168" data-mp="2mjepoknmndcl">
              <span className="rounded-full bg-court-950 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-ball sm:px-4 sm:py-1.5 sm:text-xs" data-id="element-169" data-mp="2igidbbookdh3">
                Save $291
              </span>
              <span className="rounded-full border border-court-950/15 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-court-950 sm:px-4 sm:py-1.5 sm:text-xs" data-id="element-170" data-mp="2ri854imh5efe">
                Lifetime access
              </span>
            </div>
          </div>

          <div className="rounded-xl border border-court-950/10 bg-white p-3.5 sm:rounded-2xl sm:p-7" data-id="element-171" data-mp="319m8j1hjqydt">
            <p className="text-[9px] font-bold uppercase tracking-[0.16em] text-court-600 sm:text-[11px] sm:tracking-[0.18em]" data-id="element-172" data-mp="3f4y398vpcouq">
              What's included
            </p>
            <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5 sm:mt-5 sm:grid-cols-1 sm:gap-3" data-id="element-173" data-mp="18iikz9dczn9t">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-1.5 text-[10px] leading-snug text-court-800 sm:gap-3 sm:text-sm" data-id="element-174" data-mp="1i93jkwt18rsq">
                  <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-court-950 sm:h-4 sm:w-4" strokeWidth={3} aria-hidden="true" data-id="element-175" data-mp="pk5zqp96amxv" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-4 sm:mt-8" data-id="element-176" data-mp="ymypgo2piqll">
              <CtaButton size="hero" variant="dark" className="w-full" data-id="element-177" data-mp="13k7aqxj5jar2">
                🚀 Get Tennis 360 Now — Only $27
              </CtaButton>
              <p className="mt-2 text-center text-[10px] text-court-600 sm:mt-3 sm:text-xs" data-id="element-178" data-mp="2a23x86hp3fc2">
                Backed by our 7-day money-back guarantee
              </p>
            </div>

            <div className="mt-3 flex flex-wrap justify-center gap-x-3 gap-y-1 border-t border-court-950/10 pt-3 text-[9px] text-court-600 sm:mt-6 sm:gap-x-4 sm:gap-y-2 sm:pt-5 sm:text-[11px]" data-id="element-179" data-mp="2p2j28pobuihc">
              <span className="flex items-center gap-1 sm:gap-1.5" data-id="element-180" data-mp="2fbojvwe7c316">
                <LockIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-181" data-mp="2bcfnskvovt2g" /> Secure Payment
              </span>
              <span className="flex items-center gap-1 sm:gap-1.5" data-id="element-182" data-mp="26dciczbsrkty">
                <ZapIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-183" data-mp="21cx6ydb2snem" /> Access in 5 min
              </span>
              <span className="flex items-center gap-1 sm:gap-1.5" data-id="element-184" data-mp="1wfeuwe1rhs2e">
                <ShieldCheckIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-185" data-mp="1sd1rhwahm68s" /> 7-Day
                Guarantee
              </span>
              <span className="flex items-center gap-1 sm:gap-1.5" data-id="element-186" data-mp="3qruzlaewsy55">
                <CreditCardIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-187" data-mp="3mqjhdpyd7f6z" /> Card ·
                Bank Transfer
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}